import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container } from "react-bootstrap";
import withNavigate from "../../hocs/withNavigate";
import withToast from "../../hocs/withToast";
import { loginAsync } from "../../redux/reducers/authReducer";
import "./styles.css";
import FLock from '../../assets/Icons/FLock.svg';
import FEyeOpen from '../../assets/Icons/FEyeOpen.svg';
import FEyeClose from '../../assets/Icons/FEyeClose.svg';
import FUser from '../../assets/Icons/FUser.svg';
import Loader from "../../components/Loader";
import "react-toastify/dist/ReactToastify.css";
import ForgetPasswordModal from "./ForgetPasswordModal";

const Login = ({ navigate, notify }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/patient-enrollment")
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(loginAsync(formData))
      .unwrap()
      .then(() => {
        notify("Login successful!", "success");
        navigate("/patient-enrollment")
      })
      .catch((err) => {
        console.error("Login error:", err);
        notify("Login failed! Invalid username or password.", "error");
      });
  };

  return (
    <>
      <Container fluid className="d-flex vh-100 p-0">
        <Col md={7} className="d-flex flex-column justify-content-center align-items-center bg-white p-4">
          <div className="w-100" style={{ maxWidth: "400px" }}>
            <h1 className="text-center fw-bold">Welcome to</h1>
            <h2 className="text-center text-primary fw-semibold">LIFELEAF Monitor Portal</h2>
            <p className="text-center text-muted mt-2">Sign in using LIFELEAF Credentials</p>

            <form className="mt-3" onSubmit={handleSubmit}>
              <div className="field-wrapper input mb-3 d-flex align-items-center border-bottom p-2">
                <img src={FUser} alt="user-logo" />
                <input
                  id="email"
                  name="email"
                  type="text"
                  className="form-control border-0"
                  maxLength="64"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="field-wrapper input mb-3 d-flex align-items-center border-bottom p-2 position-relative">
                <img src={FLock} alt="lock" />
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  className="form-control border-0"
                  maxLength="64"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <span
                  className="position-absolute"
                  style={{ right: "10px", cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <img src={FEyeClose} alt="eye-close" />
                  ) : (
                    <img src={FEyeOpen} alt="eye-open" />
                  )}
                </span>
              </div>

              <button className="btn btn-primary w-100" type="submit">Log In</button>
              <div className="form-check mt-3">
                <input type="checkbox" className="form-check-input" id="keep-logged-in" />
                <label className="form-check-label" htmlFor="keep-logged-in">Keep me Logged in</label>
              </div>
            </form>
            <button className="text-primary mt-3 border-0 bg-transparent" style={{ cursor: "pointer" }} onClick={() => setShowForgotPassword(true)}>
                Forgot Password?
              </button>
          </div>
        </Col>
        <Col md={5} className="d-md-block vh-100 bg-light bg-image-login"></Col>
      </Container>
      <ForgetPasswordModal
        isOpen={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
      />
      <Loader loading={loading} />
    </>
  );
};

export default withNavigate(withToast(Login));
